/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataPointHistoryLocation } from './DataPointHistoryLocation';
import {
    DataPointHistoryLocationFromJSON,
    DataPointHistoryLocationFromJSONTyped,
    DataPointHistoryLocationToJSON,
    DataPointHistoryLocationToJSONTyped,
} from './DataPointHistoryLocation';

/**
 * Serializer to represent `DataPoint` history information.
 * @export
 * @interface DataPointHistory
 */
export interface DataPointHistory {
    /**
     * 
     * @type {string}
     * @memberof DataPointHistory
     */
    readonly id: string;
    /**
     * Timestamp when the change occurred.
     * @type {Date}
     * @memberof DataPointHistory
     */
    changedAt?: Date | null;
    /**
     * 
     * @type {DataPointHistoryLocation}
     * @memberof DataPointHistory
     */
    location: DataPointHistoryLocation;
    /**
     * Rate of emission detected (g/hr)
     * @type {number}
     * @memberof DataPointHistory
     */
    detectedRate?: number | null;
    /**
     * Uncertainty of emission detected rate (g/hr)
     * @type {number}
     * @memberof DataPointHistory
     */
    detectedRateUncertainty?: number | null;
    /**
     * Concentration of the emission (ppm)
     * @type {number}
     * @memberof DataPointHistory
     */
    concentration?: number | null;
    /**
     * Uncertainty of emission concentration value (ppm)
     * @type {number}
     * @memberof DataPointHistory
     */
    concentrationUncertainty?: number | null;
    /**
     * Detection limit (g/hr)
     * @type {number}
     * @memberof DataPointHistory
     */
    detectionLimit: number;
    /**
     * 
     * @type {string}
     * @memberof DataPointHistory
     */
    version?: string;
    /**
     * Previous values of the tracked `DataPoint.data` keys that changed (e.g. operator, sector, event_status).
     * @type {any}
     * @memberof DataPointHistory
     */
    data?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof DataPointHistory
     */
    readonly createdAt: Date | null;
}

/**
 * Check if a given object implements the DataPointHistory interface.
 */
export function instanceOfDataPointHistory(value: object): value is DataPointHistory {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if ((!('detectionLimit' in (value as Record<string, any>)) && !('detection_limit' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectionLimit'] === undefined && (value as Record<string, any>)['detection_limit'] === undefined)) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    return true;
}

export function DataPointHistoryFromJSON(json: any): DataPointHistory {
    return DataPointHistoryFromJSONTyped(json, false);
}

export function DataPointHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPointHistory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'changedAt': json['changed_at'] === undefined ? undefined : json['changed_at'] === null ? null : (new Date(json['changed_at'])),
        'location': DataPointHistoryLocationFromJSON(json['location']),
        'detectedRate': json['detected_rate'] === undefined ? undefined : json['detected_rate'] === null ? null : json['detected_rate'],
        'detectedRateUncertainty': json['detected_rate_uncertainty'] === undefined ? undefined : json['detected_rate_uncertainty'] === null ? null : json['detected_rate_uncertainty'],
        'concentration': json['concentration'] === undefined ? undefined : json['concentration'] === null ? null : json['concentration'],
        'concentrationUncertainty': json['concentration_uncertainty'] === undefined ? undefined : json['concentration_uncertainty'] === null ? null : json['concentration_uncertainty'],
        'detectionLimit': json['detection_limit'],
        'version': json['version'] == null ? undefined : json['version'],
        'data': json['data'] === undefined ? undefined : json['data'] === null ? null : json['data'],
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
    };
}

export function DataPointHistoryToJSON(json: any): DataPointHistory {
    return DataPointHistoryToJSONTyped(json, false);
}

export function DataPointHistoryToJSONTyped(value?: Omit<DataPointHistory, 'id'|'createdAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'changed_at': value['changedAt'] == null ? value['changedAt'] : value['changedAt'].toISOString(),
        'location': DataPointHistoryLocationToJSON(value['location']),
        'detected_rate': value['detectedRate'],
        'detected_rate_uncertainty': value['detectedRateUncertainty'],
        'concentration': value['concentration'],
        'concentration_uncertainty': value['concentrationUncertainty'],
        'detection_limit': value['detectionLimit'],
        'version': value['version'],
        'data': value['data'],
    };
}

